import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import { Divider } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useMutation } from '@tanstack/react-query'
import NotificationAPI from 'api/faber/NotificationAPI'
import OrbitSession from 'hooks/useCookies'

export default function ResendReceiptDialog({
  receiptDialogOpen,
  handleDialogClose,
  transanctionNo,
  email,
  transactionType
}: ReceiptDialog) {
  const faberToken = OrbitSession.get('faberToken')

  const {
    mutate: sendSubscriptionReceipt,
    isLoading: isReceiptSendingLoading
  } = useMutation(NotificationAPI.sendSubscriptionReceipt, {
    onSettled: () => {
      handleDialogClose()
    },
    onSuccess: () => {
      toast.success('Receipt successfully sent')
    },
    onError: () => {
      toast.error('There is an error sending receipt to customer')
    }
  })

  const {
    mutate: sendOtpackReceipt,
    isLoading: isOtpackReceiptSendingLoading
  } = useMutation(NotificationAPI.sendOtpackReceipt, {
    onSettled: () => {
      handleDialogClose()
    },
    onSuccess: () => {
      toast.success('Receipt successfully sent')
    },
    onError: () => {
      toast.error('There is an error sending receipt to customer')
    }
  })

  const resendReceipt = () => {
    if (transactionType?.includes('ONETIMEPACK')) {
      sendOtpackReceipt({
        paymentId: transanctionNo,
        faberToken: faberToken
      })
    } else {
      sendSubscriptionReceipt({
        paymentId: transanctionNo,
        faberToken: faberToken
      })
    }
  }

  return (
    <Dialog
      open={receiptDialogOpen}
      onClose={handleDialogClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title' sx={{ fontSize: '1.2em' }}>
        Send Receipt
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          By taking this step, the customer will receive the receipt for the
          specific transaction: <b>{transanctionNo}</b>.<br /> The receipt will
          be sent to <b>{email}</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose}>Cancel</Button>
        <LoadingButton
          variant='contained'
          onClick={resendReceipt}
          loading={isReceiptSendingLoading || isOtpackReceiptSendingLoading}
          autoFocus
        >
          Send Receipt
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

interface ReceiptDialog {
  receiptDialogOpen: boolean
  handleDialogClose: () => void
  transanctionNo: string
  email: string
  transactionType: string
}
